import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { OnlineSchedulingParams } from 'interfaces/onlineSchedulingParams';

export interface AppointmentPeriodData {
  totalAppointmentsByService: {
    serviceName: string;
    total: number;
  };
  totalAppointments: number;
  period: {
    startDate: string;
    endDate: string;
  };
  details: {
    date: string;
    totalAppointments: number;
  }[];
}

export interface TotalAppointmentData {
  lastPeriodData: AppointmentPeriodData;
  periodData: AppointmentPeriodData;
}

interface RoiAppointmentParams extends OnlineSchedulingParams {
  status?: string;
}

const useRoiAppointment = (params: RoiAppointmentParams) => {
  const storedId = loadSelectedClinicId();
  const clinicIds = params.clinicIds ?? [storedId];
  const query =
    params.startDate && params.endDate
      ? new URLSearchParams({
          startDate: params.startDate,
          endDate: params.endDate,
          hourType: params.hourType,
          ...(params.status && { status: params.status }),
        }).toString()
      : '';

  const url =
    params.startDate && params.endDate ? `/rois/appointments?${query}` : null;

  const { data, error, isValidating, mutate } = useSWR(
    url ? [url, clinicIds] : null,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<TotalAppointmentData>(url, {
        params: { clinicIds },
      });
      return response.data;
    }
  );

  if (!params.startDate || !params.endDate) {
    return {
      data: null,
      error: undefined,
      isLoading: false,
      isValidating: false,
      mutate: async () => {},
    };
  }

  return {
    data,
    error,
    isLoading: !data && !error,
    isValidating,
    mutate,
  };
};

export default useRoiAppointment;
